import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default Leaflet marker icons (Webpack breaks default paths)
const DefaultIcon = L.icon({
    iconUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon.png",
    iconRetinaUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    shadowUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

/**
 * Display-only mini map for a hotel location.
 * Props:
 *   lat, lng   - hotel coordinates
 *   name       - hotel name (for popup)
 *   height     - CSS height, default 320px
 *   zoom       - initial zoom, default 14
 */
export default function HotelMap({ lat, lng, name = "Otel", height = 320, zoom = 14 }) {
    useEffect(() => {
        // Force Leaflet to recompute size after mount (fixes blank tiles inside flex/grid)
        setTimeout(() => {
            const evt = new Event("resize");
            window.dispatchEvent(evt);
        }, 200);
    }, []);

    if (!lat || !lng) {
        return (
            <div
                data-testid="hotel-map-empty"
                className="w-full rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-sm text-slate-500"
                style={{ height }}
            >
                Bu otel için harita konumu eklenmemiş.
            </div>
        );
    }

    return (
        <div
            data-testid="hotel-map"
            className="w-full rounded-2xl overflow-hidden border border-slate-200 dark:border-slate-800 relative z-0"
            style={{ height }}
        >
            <MapContainer
                center={[lat, lng]}
                zoom={zoom}
                scrollWheelZoom={false}
                style={{ height: "100%", width: "100%" }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[lat, lng]}>
                    <Popup>
                        <strong>{name}</strong>
                    </Popup>
                </Marker>
            </MapContainer>
        </div>
    );
}
